var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 74,
    viewBox: "0 0 58 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ta7k7vdj8a",
    d: "M0 0.686L56.933 0.686 56.933 72.291 0 72.291z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.796) translate(0 .023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n2d5pyxdqb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ta7k7vdj8a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M46.477 48.601C34.311 67.203 16.371 76.86 6.43 70.169c-9.952-6.68-8.154-27.188 4.024-45.79C22.63 5.782 40.562-3.883 50.503 2.805c9.952 6.683 8.155 27.188-4.026 45.795",
    mask: "url(#n2d5pyxdqb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M31.68 48.654c0 1.848-1.497 3.347-3.343 3.347-1.846 0-3.346-1.5-3.346-3.347 0-1.848 1.5-3.345 3.346-3.345s3.343 1.497 3.343 3.345",
    transform: "translate(.796)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M25.333 22.638c-.252 0-.406.148-.46.211-.07.078-.18.246-.151.488l2.108 17.03h3.01l2.112-17.03c.027-.236-.08-.405-.148-.486-.074-.081-.228-.213-.465-.213h-6.006zm.536 19.924c-.547 0-1.01-.413-1.08-.96L22.562 23.61c-.099-.8.149-1.609.679-2.216.53-.606 1.292-.954 2.092-.954h6.006c.8 0 1.564.348 2.093.954.531.608.776 1.415.676 2.215l-2.226 17.993c-.067.546-.531.96-1.078.96h-4.935z",
    transform: "translate(.796)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.26737fb3593275191551034dc3ec587a.svg";
export { ForwardRef as ReactComponent };